module.exports = __webpack_public_path__ + "static/media/16UNODC13.04c323c1.jpg";